import { useEffect, useState } from "react";
import { useAppSelector } from "../../../store/hooks";
import Animation from "../../Animation";
import Separator from "../../Separator";
import AddNewBankCategory from "./components/AddNewBankCategory";
import BankAddQuestion from "./components/BankAddQuestion";
import FetchQuestions from "./components/FetchQuestions";
import Qimg from "./components/Qimg";
import "./styles.css";

const QuestionBank = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [questionsData, setQuestionsData] = useState(null);
  // const [teacherBankCats, setTeacherBankCats] = useState([]);

  // useEffect(() => {
  //   handleGetBankCategories(setTeacherBankCats);
  // }, []);

  const { userProfileData } = useAppSelector((state) => state.store);

  const teacherBankCats = userProfileData?.bank_categories ?? [];

  useEffect(() => {
    console.log({ questionsData });
  }, [questionsData]);

  return (
    <Animation>
      <div className="space-y-6">
        <h3 className="bg-primary p-3 text-white rounded-lg shadow fw-bold">
          بنك الأسئلة
        </h3>
        <div className="p-3 bg-white rounded-lg border shadow-sm">
          <BankAddQuestion teacherBankCats={teacherBankCats} />
          <Separator />
          <AddNewBankCategory />
          <Separator />
          <FetchQuestions
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            teacherBankCats={teacherBankCats}
            setQuestionsData={setQuestionsData}
          />
          <div className="questions-grid">
            {questionsData &&
              questionsData.map((question) => (
                <Qimg
                  question={question}
                  questionsData={questionsData}
                  setQuestionsData={setQuestionsData}
                  paragraph={question.content}
                  weight={question.weight}
                  src={question.image_url}
                  alt={""}
                  deleteButton={true}
                />
              ))}
          </div>
        </div>
      </div>
    </Animation>
  );
};

export default QuestionBank;
